import globalProvider from "./src/globalProvider"
export const wrapRootElement = globalProvider
